import { createI18n } from "vue-i18n";

import deMessages from "./locales/de.json";
import enMessages from "./locales/en.json";

export const componentsI18n = createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  messages: { de: deMessages, en: enMessages },
  missingWarn: false,
  fallbackWarn: false,
});

export const $t = (key: string, params?: Record<string, unknown>): string => componentsI18n.global.t(key, params ?? {});

export const setLocale = (locale: string): void => {
  (componentsI18n.global.locale as { value: string }).value = locale;
};
